export default "__VITE_ASSET__71c620ef__"